import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { isEmpty } from 'lodash';

export default function PrivateRoute({ element }) {
  const location = useLocation();

  const token = useSelector(state => state.app.token);
  const authenticated = !isEmpty(token);

  if (!authenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return element; // render the element directly
}
